// extracted by mini-css-extract-plugin
module.exports = {"identification":"Identification_identification__1du4V","radioGroup":"Identification_radioGroup__2fcyt","simulationCheck":"Identification_simulationCheck__1THu4"};